module.exports = __webpack_public_path__ + "img/planet-venus-internal.1c386507.svg";